//tools
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios';
const tools = {
    //search内容解析
    parseQueryString(queryString = window.location.search) {
        let kv
        let result = {}
        let bool = { true: true, false: false }
        let searchStr = queryString.indexOf('?') === 0 ? queryString.substr(1) : queryString
        searchStr = searchStr ? searchStr.split('&') : ''
        for (let i = 0; i < searchStr.length; i++) {
            kv = searchStr[i].split('=')
            kv[1] = /* decodeURIComponent(kv[1]) */ kv[1];
            kv[1] = _.isUndefined(bool[kv[1]]) ? kv[1] : bool[kv[1]]
            result[kv[0]] = kv[1]
        }
        return result
    },
    //对象判空
    isEmptyObject(obj) {
        for (var key in obj) {
            return false;
        }
        return true;
    },
    //主要是为了比较两个json的差异
    diff(obj1, obj2) {
        const result = {};
        if (Object.is(obj1, obj2)) {
            return undefined;
        }
        if (!obj2 || typeof obj2 !== 'object') {
            return obj2;
        }
        Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach(key => {
            if (obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
                result[key] = obj2[key];
            }
            if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
                const value = diff(obj1[key], obj2[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
        });
        return result;
    }
}

/**
 * 获取格式化之后的时间
 * @param time {time} 时间
 * @returns {string} 格式化之后的时间字符串
 */
export const getFormatDate = function (time) {
    if (!time) {
        return ''
    }
    return moment(time).format('YYYY-MM-DD')
}

/**
 * 轮询图片地址，直到请求成功或者达到设定次数上限
 * @param imgSrc {string} 需要轮询的图片地址
 * @param tryTime {number} 尝试的次数
 * @param interval {number} 每次尝试的间隔单位：ms
 * @return {Promise<boolean>} 规定次数内是否请求成功
 */
export const waitImageUrlAvailable = async function (imgSrc, tryTime, interval) {
    let t;
    await new Promise((resolve, reject) => {
        t = setInterval(() => {
            if (imgSrc.indexOf("mp4") >= 0 || imgSrc.indexOf("mov") >= 0) {
                let video = document.createElement('video');
                video.onload = function () {
                    clearInterval(t)
                    resolve()
                }
                video.onerror = function () {

                }
                video.src = imgSrc;
                video.oncanplaythrough = function () {
                    clearInterval(t)
                    resolve()
                };
            } else {
                axios
                    .get(imgSrc)
                    .then((res) => {
                        clearInterval(t)
                        resolve()
                    }).catch(e => {

                    });
            }
        }, 2000)
    })
    return true
}

export const getCharLength = function (str) {
    return str.replace(/[^\x00-\xff]/g, "00").length
}

export const getIsVideo = function (src) {
    return /.(swf|flv|mp4|rmvb|avi|mpeg|ra|ram|mov|wmv)/.test(src)
}
export const getIsPicture = function (src) {
    return /.(png|jpg|jpeg|gif|svg)/.test(src)
}
export default tools;